<template>
	<b-row>
		<b-col cols="12">
			<ManualDocuments />
		</b-col>
	</b-row>
</template>

<script>
import ManualDocuments from '@/views/CustomerProfile/CenterComponents/Documents/ManualDocuments'

export default {
	components: {
		ManualDocuments
	}
}
</script>